import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Container from '@mui/material/Container';
import Typography from '../components/Typography';
import TextField from '../components/TextField';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import TestImage from '../../static/themes/foundry/test.png';
import Tooltip from '@mui/material/Tooltip';


function Copyright() {
  return (
    <React.Fragment>
      {'© '}
      <Link color="inherit" href="https://presentation-skill.gallerylambda.com">
        Gallery Λ
      </Link>{' '}
      {new Date().getFullYear()}
    </React.Fragment>
  );
}

const iconStyle = {
  width: 48,
  height: 48,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'warning.main',
  mr: 1,
  '&:hover': {
    bgcolor: 'warning.dark',
  },
};

const LANGUAGES = [
  {
    code: 'en-US',
    name: 'Japanese',
  },
  {
    code: 'n.a.',
    name: 'Only Japanese Available For Now',
  },
];

const TOP_PAGE = [
  {
    label: 'Top Page',
    link: '/',
  },
  // Add more links as needed

];


const ABOUT_US = [
  {
    label: 'Gallery Λ',
    link: '/about/',
  },
  // Add more links as needed
];

export default function AppFooter() {
  return (
    <Typography
      component="footer"
      sx={{ display: 'flex', bgcolor: 'secondary.light' }}
    >
      <Container sx={{ my: 8, display: 'flex' }}>
        <Grid container spacing={4}>
          <Grid item xs={4} sm={2} md={2}>
            <Typography variant="h6" marked="left" gutterBottom
              sx={{
                fontSize: 18,
                fontWeight: 'normal',
              }}>
              Home
            </Typography>
            <Box component="ul" sx={{ m: 0, listStyle: 'none', p: 0 }}>
              {TOP_PAGE.map((item) => (
                <Box component="li" sx={{ py: 0.5 }} key={item.label}>
                  <Link href={item.link}>{item.label}</Link>
                </Box>
              ))}
            </Box>
          </Grid>
          <Grid item xs={4} sm={2} md={2}>
            <Typography variant="h6" marked="left" gutterBottom
              sx={{
                fontSize: 18,
                fontWeight: 'normal',
              }}>
              About Us
            </Typography>
            <Box component="ul" sx={{ m: 0, listStyle: 'none', p: 0 }}>
              {ABOUT_US.map((item) => (
                <Box component="li" sx={{ py: 0.5 }} key={item.label}>
                  <Link href={item.link}>{item.label}</Link>
                </Box>
              ))}
            </Box>
          </Grid>
          <Grid item xs={4} sm={2} md={2}>
            <Typography variant="h6" marked="left" gutterBottom
              sx={{
                fontSize: 18,
                fontWeight: 'normal',
              }}>
              Our SNS
            </Typography>
            <Grid
              container
              direction="column"
              justifyContent="flex-end"
              spacing={8}
              sx={{ height: 120 }}
            >
              <Grid item sx={{ my: 2, display: 'flex', gap: '10px' }}>
                <Tooltip title="Coming Soon!">
                  <Box component="a" href="/">
                    <InstagramIcon color="primary" sx={{ fontSize: 30 }} />
                    {/* <img
                    src="/static/themes/onepirate/appFooterFacebook.png"
                    alt="Facebook"
                  /> */}
                  </Box>
                </Tooltip>
                <Tooltip title="Coming Soon!">
                  <Box component="a" href="/">
                    {/* <Box component="a" href="https://twitter.com/MUI_hq" sx={iconStyle}> */}
                    <TwitterIcon color="primary" sx={{ fontSize: 30 }} />
                    {/* <img
                    src="/hoge/"
                    // src={TestImage}
                    alt="Twitter"
                  /> */}
                  </Box>
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={4} sm={2} md={2}>
            <Typography variant="h6" marked="left" gutterBottom
              sx={{
                fontSize: 18,
                fontWeight: 'normal',
              }}>
              Legal
            </Typography>
            <Box component="ul" sx={{ m: 0, listStyle: 'none', p: 0 }}>
              <Box component="li" sx={{ py: 0.5 }}>
                <Link href="/terms/">Terms</Link>
              </Box>
              <Box component="li" sx={{ py: 0.5 }}>
                <Link href="/privacy/">Privacy</Link>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={4} sm={2} md={2}>
            <Typography variant="h6" marked="left" gutterBottom
              sx={{
                fontSize: 18,
                fontWeight: 'normal',
              }}>
              Language
            </Typography>
            <TextField
              select
              size="medium"
              variant="standard"
              SelectProps={{
                native: true,
              }}
              inputProps={{
                style: {
                  backgroundColor: 'white',  // Change this to the desired background color
                },
              }}
              sx={{ mt: 1, width: 100 }}
            >
              {LANGUAGES.map((language) => (
                <option value={language.code} key={language.code}>
                  {language.name}
                </option>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={4} sm={2} md={2}>
            <Typography variant="h6" marked="left" gutterBottom
              sx={{
                fontSize: 18,
                fontWeight: 'normal',
              }}>
              Copyright
            </Typography>
            {/* <Typography variant="h6" marked="left" gutterBottom> Copyright </Typography> */}
            <Copyright />
          </Grid>
          <Grid item>
            <Typography variant="caption">
              {'Icons made by '}
              <Link href="https://www.freepik.com" rel="sponsored" title="Freepik">
                Freepik
              </Link>
              {' from '}
              <Link href="https://www.flaticon.com" rel="sponsored" title="Flaticon">
                www.flaticon.com
              </Link>
              {' is licensed by '}
              <Link
                href="https://creativecommons.org/licenses/by/3.0/"
                title="Creative Commons BY 3.0"
                target="_blank"
                rel="noopener noreferrer"
              >
                CC 3.0 BY
              </Link>
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Typography>
  );
}
